module.exports = __webpack_public_path__ + "static/media/om_eyeshape_downturned_lightbrown.0de03e8a.png";